import './styles.css';

export default function RoundStatus({ isActive = false }) {
  return (
    <span className={`tournament-round-status ${isActive ? 'active' : ''}`}></span>
  );
}
